import React from "react";
import { Navigate } from "react-router-dom";
import { useDistributorAuth } from "./context/DistributorAuthContext";

const PrivateDistributorRoute = ({ children }) => {
  const { distributor } = useDistributorAuth();

  if (!distributor) {
    return <Navigate to="/distributor/login" replace />;
  }

  return children;
};

export default PrivateDistributorRoute;
